export default __webpack_public_path__ + "static/media/listingImage0.9460c290.jpg";